import { Component, Input, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ProductCardComponent } from './product-card.component';
import { Product } from '../../core/models/interfaces-general';

@Component({
  selector: 'app-product-carousel-section',
  standalone: true,
  imports: [CommonModule, RouterLink, ProductCardComponent],
  template: `
    <section class="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-10">
      
      <!-- ENCABEZADO: TÍTULO Y BOTÓN VER TODOS -->
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
        <h2 
          class="text-lg sm:text-xl md:text-2xl tracking-tight max-w-2xl"
          style="color: var(--text-accent);"
        >
          {{ title }}
        </h2>

        <a 
          *ngIf="viewAllUrl"
          [routerLink]="viewAllUrl"
          class="px-5 py-2 rounded-xl text-xs font-bold border-2 tracking-wider transition-all duration-300 hover:bg-rose-500 hover:!text-white uppercase whitespace-nowrap"
          style="border-color: var(--bg-main); color: var(--bg-main);"
        >
          {{ viewAllText }}
        </a>
      </div>

      <!-- CONTENEDOR CARRUSEL -->
      <div class="relative">
        <!-- Lista Deslizable -->
        <div 
          #scrollContainer
          class="flex gap-4 sm:gap-6 overflow-x-auto scrollbar-hide scroll-smooth py-4 px-1"
        >
          <div 
            *ngFor="let product of products" 
            class="w-[240px] sm:w-[260px] md:w-[280px] flex-shrink-0"
          >
            <app-product-card [product]="product"></app-product-card>
          </div>
        </div>

        <!-- FLECHAS DE NAVEGACIÓN (INFERIOR / FLOTANTES) -->
        <div class="flex justify-end items-center gap-3 mt-4 pr-2">
          <!-- Flecha Izquierda -->
          <button 
            (click)="scrollLeft()"
            class="w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:bg-gray-100 transition-colors border border-gray-100"
            aria-label="Anterior"
          >
            <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <!-- Flecha Derecha -->
          <button 
            (click)="scrollRight()"
            class="w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:bg-gray-100 transition-colors border border-gray-100"
            aria-label="Siguiente"
          >
            <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>

    </section>
  `,
  styles: [`
    /* Ocultar barra de scroll nativa para vista limpia */
    .scrollbar-hide::-webkit-scrollbar {
      display: none;
    }
    .scrollbar-hide {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
  `]
})
export class ProductCarouselSectionComponent {
  @Input({ required: true }) title: string = '';
  @Input({ required: true }) products: Product[] = [];
  @Input() viewAllUrl: string = '#';
  @Input() viewAllText: string = 'VER TODOS';

  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;

  scrollLeft() {
    this.scrollContainer.nativeElement.scrollBy({ left: -300, behavior: 'smooth' });
  }

  scrollRight() {
    this.scrollContainer.nativeElement.scrollBy({ left: 300, behavior: 'smooth' });
  }
}